import { PageWidget } from 'app/src/shared/components'
import { NavigatePaths, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { type PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

export const UserAccountOrderDetailDialog: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation()
  const navigate = useWelfarePortalNavigate()
  const { t } = useTranslation('home')

  const onGoBackButton = () => {
    navigate.goToUserAccount()
  }

  return (
    <>
      {pathname !== NavigatePaths.UserAccount && (
        <PageWidget>
          <Button link onClick={onGoBackButton} icon='pi pi-arrow-left' pt={{ root: { className: 'mb-2' } }}>
            <span className='ml-2 font-bold'>{t('AppBar.UserAccount')}</span>
          </Button>
        </PageWidget>
      )}
      {children}
    </>
  )
}
